module.exports = __webpack_public_path__ + "media/images/ad1-5f5de1d168281b864039157b4b4959f5.png";